import { getRailsClient } from "../client";

const levelsApiBase = "/api/internal_api/v1/levels";
const LevelMetadataApiRoute = `${levelsApiBase}?filter[]=courses`;
const LevelByIdRoute = (levelId: number) => `${levelsApiBase}/${levelId}/roles`;

export const getLevelMetadata = async () => {
  const response = await getRailsClient({ useToast: true }).get(LevelMetadataApiRoute);

  if (response.status === 200) {
    return response.data.courses.map((level: any) => ({
      id: level.id,
      name: level.name,
      description: level.description,
      status: level.status,
      rankName: level.rank_name,
      role: level.role,
    }));
  } else {
    throw new Error(
      `getLevelMetadata: Unable to get level metadata, status code ${response.status}`
    );
  }
};

export const getLevelById = async (levelId: number) => {
  const response = await getRailsClient({ useToast: true }).get(LevelByIdRoute(levelId));

  if (response.status === 200) {
    return response.data.roles;
  } else {
    throw new Error(`getLevelById: Unable to get level by ID, status code ${response.status}`);
  }
};
